import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

export default function LandingHero({ onRegisterAsBusinessClick, onRegisterClick }) {
  const { t } = useTranslation();
  const [brief, setBrief] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const handler = onRegisterAsBusinessClick || onRegisterClick;
    if (handler) handler();
  };

  return (
    <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-4xl mx-auto text-center">
        
        {/* Optional eyebrow */}
        <div className="mb-6">
          <span className="text-sm font-medium text-muted-foreground">
            {t('landing.hero.eyebrow')}
          </span>
        </div>

        {/* Hero heading */}
        <h1 className="font-heading text-5xl md:text-6xl font-bold tracking-[-0.03em] text-foreground mb-4">
          {t('landing.hero.title')}
        </h1>

        {/* Subheading */}
        <p className="font-body text-base md:text-lg leading-[1.55] text-brand-ink mb-8 max-w-2xl mx-auto">
          {t('landing.hero.description')}
        </p>

        {/* Composer form */}
        <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-4">
          <textarea
            value={brief}
            onChange={(e) => setBrief(e.target.value)}
            placeholder={t('landing.hero.composerPlaceholder')}
            rows={4}
            className="w-full px-4 py-3 rounded-lg border border-border font-body text-[15px] resize-y"
          />
          
          <Button
            type="submit"
            size="lg"
            className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium text-base px-8 py-6 rounded-full group shadow-lg"
            data-testid="hero-create-rfp-btn"
          >
            {t('landing.hero.ctaPrimary')}
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>

          {/* Under-CTA locked line */}
          <p className="text-sm text-muted-foreground mt-3">
            {t('landing.hero.underCta')}
          </p>
        </form>

      </div>
    </section>
  );
}
